import { render, staticRenderFns } from "./AnalysisDashboard.vue?vue&type=template&id=12953c82&scoped=true"
import script from "./AnalysisDashboard.vue?vue&type=script&lang=ts"
export * from "./AnalysisDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12953c82",
  null
  
)

export default component.exports